import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import axios from "axios";
import {
  Table,
  Button,
  Row,
  Col,
  ButtonGroup,
  Input,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import Swal from "sweetalert2";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";
import * as XLSX from "xlsx";

/** =========================
 *  Checkbox dropdown (reusable)
 *  ========================= */
function MultiSelectCheckbox({
  items,
  selected,
  setSelected,
  getId,
  getLabel,
  searchPlaceholder = "Buscar...",
}) {
  const [q, setQ] = useState("");

  const list = useMemo(() => {
    const base = [...(items || [])].sort((a, b) =>
      (getLabel(a) || "").localeCompare(getLabel(b) || "", "es", {
        sensitivity: "base",
      })
    );

    if (!q) return base;
    const qq = q.toLowerCase();
    return base.filter((it) => (getLabel(it) || "").toLowerCase().includes(qq));
  }, [items, q, getLabel]);

  const toggle = (id) => {
    const sid = String(id);
    setSelected((prev) =>
      prev.includes(sid) ? prev.filter((x) => x !== sid) : [...prev, sid]
    );
  };

  const selectAllVisible = () => {
    const visibleIds = list.map((it) => String(getId(it)));
    setSelected((prev) => Array.from(new Set([...prev, ...visibleIds])));
  };

  const clearAll = () => setSelected([]);

  return (
    <div>
      <Input
        bsSize="sm"
        placeholder={searchPlaceholder}
        value={q}
        onChange={(e) => setQ(e.target.value)}
      />

      <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
        <Button size="sm" color="secondary" outline onClick={selectAllVisible}>
          Todos (visibles)
        </Button>
        <Button size="sm" color="secondary" outline onClick={clearAll}>
          Limpiar
        </Button>
      </div>

      <div
        style={{
          marginTop: 8,
          maxHeight: 240,
          overflowY: "auto",
          paddingRight: 6,
        }}
      >
        {list.map((it) => {
          const id = String(getId(it));
          const checked = selected.includes(id);

          return (
            <label
              key={id}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                padding: "6px 4px",
                cursor: "pointer",
                userSelect: "none",
              }}
            >
              <input
                type="checkbox"
                checked={checked}
                onChange={() => toggle(id)}
              />
              <span style={{ fontSize: 13 }}>{getLabel(it)}</span>
            </label>
          );
        })}

        {!list.length && (
          <div style={{ padding: 10, fontSize: 13, opacity: 0.7 }}>
            Sin resultados
          </div>
        )}
      </div>
    </div>
  );
}

function ListadoGastosContenedor() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_GASTOS_CONTENEDOR = process.env.REACT_APP_URL_GASTOS_CONTENEDOR;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_CONTENEDORES = process.env.REACT_APP_URL_CONTENEDORES;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_CONCEPTOS_GASTOS = process.env.REACT_APP_URL_CONCEPTOS_GASTOS;
  const URL_BANCOS = process.env.REACT_APP_URL_BANCOS;
  const [t] = useTranslation("global");

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 30);
  let inicio2 = moment(inicio).format("YYYY-MM-DD");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(inicio2);
  const [selectedFechaFin, setSelectedFechaFin] = useState(hoy);
  const [selectedMayorQue, setSelectedMayorQue] = useState(0);
  const [selectedMenorQue, setSelectedMenorQue] = useState(100000000);
    const [totalTotalGastos, setTotalTotalGastos] = useState(0);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalArchivo, setModalArchivo] = useState(false);
  const toggleArchivo = () => setModalArchivo(!modalArchivo);
  const [fechaGasto, setFechaGasto] = useState(hoy);
  const [totalMonto, setTotalMonto] = useState(0);
  const [validaBoton, setValidaBoton] = useState(true);
  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
    const [selectedActivo, setSelectedActivo] = useState('Si');

  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      contenedores: "",
      contenedoresNombre: "",
      cliente: "",
      clienteNombre: "",
      descripcion: "NA",
      monto: 0,
    },
  ]);

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);
  const [idEdit, setIdEdit] = useState();
  const [fecha, setFecha] = useState(hoy);
  const [totalUSD, setTotalUSD] = useState(0);
  const [tipoCambio, setTipoCambio] = useState(1);
  const [total, setTotal] = useState(0);
  const [descripcion, setDescripcion] = useState("NA");

  const [conceptosGastos, setConceptosGastos] = useState([]);
  const [selectedConcepto, setSelectedConcepto] = useState("");

  // ✅ ahora multi conceptos
  const [selectedConceptoFiltro, setSelectedConceptoFiltro] = useState([]);

  // ✅ multi clientes
  const [selectedClienteFiltro, setSelectedClienteFiltro] = useState([]);

  const [selectedDuplicadoFiltro, setSelectedDuplicadoFiltro] = useState("");
  const [bancos, setBancos] = useState([]);
  const [selectedBanco, setSelectedBanco] = useState("");
  const [contenedores, setContenedores] = useState([]);
  const [selectedContenedor, setSelectedContenedor] = useState("");
  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [selectedProveedorFiltro, setSelectedProveedorFiltro] = useState("");
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [moneda, setMoneda] = useState("MXN");
  const [validado, setValidado] = useState("");

  const [modalObs, setModalObs] = useState(false);
  const [observacionesPDF, setObservacionesPDF] = useState("");
  const toggleModalObs = () => setModalObs((v) => !v);

  const [selectedCancelIds, setSelectedCancelIds] = useState([]);
  // IDs desmarcados para el PDF. Vacío = todos incluidos (default).
  const [excludedPdfIds, setExcludedPdfIds] = useState([]);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  /** =========================
   *  Cargar gastos
   *  ========================= */
  useEffect(() => {
    axios
      .get(
        `${URL_GASTOS_CONTENEDOR}Fechas/${selectedFechaInicio}/${selectedFechaFin}`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then((response) => {
        let allGastos = response.data || [];

        const gastosActivos = allGastos.filter((a) => a.is_active === "Si");

        const conteoDuplicados = {};
        gastosActivos.forEach((a) => {
          const key = `${a?.contenedores?.[0]?._id}-${a?.conceptosGastos?.[0]?._id}`;
          conteoDuplicados[key] = (conteoDuplicados[key] || 0) + 1;
        });

        let arrayTabla = allGastos
          .sort((a, b) => (a.fecha < b.fecha ? 1 : -1))
          .map((a) => {
            const key = `${a?.contenedores?.[0]?._id}-${a?.conceptosGastos?.[0]?._id}`;
            const esDuplicado =
              a.is_active === "Si" && conteoDuplicados[key] > 1 ? "Si" : "No";

            return {
              _id: a._id,
              numero: a.idGastoContenedor,
              fecha: a.fecha,
              descripcion: a.descripcion,
              totalUSD: a.totalUSD,
              tipoCambio: a.tipoCambio,
              total: a.total,
              concepto: a?.conceptosGastos?.[0]?.name || "",
              cliente: a?.clientes?.[0]?.nombre_comercial || "",
              idCliente: a?.clientes?.[0]?._id ? String(a.clientes[0]._id) : "",
              contenedor: a?.contenedores?.[0]?.contenedor || "",
              numeroContenedor: a?.contenedores?.[0]?.idContenedor || "",
              referencia: a?.contenedores?.[0]?.referencia || "",
              numeroBl: a?.contenedores?.[0]?.numeroBl || "",
              idContenedor: a?.contenedores?.[0]?._id || "",
              proveedor: a?.proveedores?.[0]?.name || "",
              idProveedor: a?.proveedores?.[0]?._id || "",
              datosBancarios: a?.proveedores?.[0]?.datosBancarios,
              idConceptosGastos: a?.conceptosGastos?.[0]?._id
                ? String(a.conceptosGastos[0]._id)
                : "",
              moneda: a.moneda,
              saldo: a.saldo,
              abonos: a.abonos,
              is_active: a.is_active,
              validado: a.validado,
              autorizado: a.autorizado,
              banco:
                (a?.bancos?.[0]?.banco || "") +
                " " +
                (a?.bancos?.[0]?.cuenta || ""),
              idBanco: a?.bancos?.[0]?._id || "",
              gastoDuplicado: esDuplicado,
              cuentaBancaria: a.cuentaBancaria,
            };
          });

        setComments(arrayTabla);
      })
      .catch((err) => console.log(err));
  }, [user, selectedFechaInicio, selectedFechaFin, URL_GASTOS_CONTENEDOR]);

  useEffect(() => {
    const headersReq = {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    };

    axios
      .get(URL_CONCEPTOS_GASTOS, headersReq)
      .then((res) => setConceptosGastos(res.data || []))
      .catch(console.log);

    axios
      .get(URL_BANCOS, headersReq)
      .then((res) => setBancos(res.data || []))
      .catch(console.log);

    axios
      .get(URL_CONTENEDORES, headersReq)
      .then((res) => setContenedores(res.data || []))
      .catch(console.log);

    axios
      .get(URL_CLIENTES, headersReq)
      .then((res) => setClientes(res.data || []))
      .catch(console.log);

    axios
      .get(URL_PROVEEDORES, headersReq)
      .then((res) => setProveedores(res.data || []))
      .catch(console.log);
  }, [
    URL_CONCEPTOS_GASTOS,
    URL_BANCOS,
    URL_CONTENEDORES,
    URL_CLIENTES,
    URL_PROVEEDORES,
  ]);

  /** =========================
   *  ✅ Solo clientes que existen en comments
   *  ========================= */
  const clientesConDatos = useMemo(() => {
    const idsEnComments = new Set(
      (comments || [])
        .map((c) => String(c.idCliente || ""))
        .filter(Boolean)
    );

    return (clientes || [])
      .filter((cl) => idsEnComments.has(String(cl._id)))
      .sort((a, b) =>
        (a.nombre_comercial || "").localeCompare(b.nombre_comercial || "", "es", {
          sensitivity: "base",
        })
      );
  }, [clientes, comments]);

  /** =========================
   *  ✅ Solo conceptos que existen en comments
   *  ========================= */
  const conceptosConDatos = useMemo(() => {
    const idsEnComments = new Set(
      (comments || [])
        .map((c) => String(c.idConceptosGastos || ""))
        .filter(Boolean)
    );

    return (conceptosGastos || [])
      .filter((cg) => idsEnComments.has(String(cg._id)))
      .sort((a, b) =>
        (a.name || "").localeCompare(b.name || "", "es", { sensitivity: "base" })
      );
  }, [conceptosGastos, comments]);

  /** =========================
   *  ✅ Limpia selecciones si ya no existen por cambio de fechas
   *  ========================= */
  useEffect(() => {
    if (!selectedClienteFiltro?.length) return;
    const allowed = new Set(clientesConDatos.map((c) => String(c._id)));
    setSelectedClienteFiltro((prev) => prev.filter((id) => allowed.has(String(id))));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientesConDatos]);

  useEffect(() => {
    if (!selectedConceptoFiltro?.length) return;
    const allowed = new Set(conceptosConDatos.map((c) => String(c._id)));
    setSelectedConceptoFiltro((prev) => prev.filter((id) => allowed.has(String(id))));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conceptosConDatos]);

  let totalTabla = 0;

  // Búsqueda que acepta VARIOS términos separados por coma (OR).
  // Ej: "ONEU4299998, TCLU1234567" trae los gastos de ambos contenedores.
  // Un solo término (sin coma) se comporta igual que antes (frase completa).
  const matchesSearch = (comment, search) => {
    if (!search) return true;
    const terms = String(search)
      .split(",")
      .map((t) => t.trim())
      .filter((t) => t.length > 0);
    if (terms.length === 0) return true;

    const matchesTerm = (raw) => {
      const s = raw.toLowerCase();
      return (
        (comment.concepto || "").toLowerCase().includes(s) ||
        (comment.contenedor || "").toLowerCase().includes(s) ||
        (comment.cliente || "").toLowerCase().includes(s) ||
        (comment.proveedor || "").toLowerCase().includes(s) ||
        (comment.validado || "").toLowerCase().includes(s) ||
        (comment.gastoDuplicado || "").toLowerCase().includes(s) ||
        String(comment.total ?? "").includes(raw) ||
        String(comment.abonos ?? "").includes(raw) ||
        String(comment.saldo ?? "").includes(raw) ||
        String(comment.referencia ?? "").includes(raw) ||
        String(comment.numero ?? "").includes(raw) ||
        String(comment.tipoCambio ?? "").includes(raw)
      );
    };

    return terms.some(matchesTerm);
  };

function PDFTabla(observaciones = "") {
  // =========================
  // Helpers
  // =========================
  const formatUSD = (v) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
    }).format(Number(v || 0));

  // Delega en el helper compartido (soporta varios contenedores por coma).
  const includesSearch = (comment, search) => matchesSearch(comment, search);

  const compareValues = (a, b, field, order = "asc") => {
    const dir = order === "desc" ? -1 : 1;
    const va = a?.[field];
    const vb = b?.[field];

    const na = Number(va);
    const nb = Number(vb);
    const bothNum = Number.isFinite(na) && Number.isFinite(nb);

    if (bothNum) return (na - nb) * dir;

    return (
      String(va ?? "").localeCompare(String(vb ?? ""), "es", {
        sensitivity: "base",
      }) * dir
    );
  };

  // ✅ FIX: recuadro con altura real según líneas envueltas
  const drawDatosBancarios = (doc, datos, startX, startY, maxWidth = 200) => {
    if (!datos) return startY;

    let y = startY;
    const innerPad = 3;
    const lineH = 5;

    const valueX = startX + 45;
    const valueW = maxWidth - 50;

    doc.setFontSize(10);
    doc.setFont(undefined, "bold");
    doc.text("Datos bancarios del proveedor", startX, y);
    doc.setFont(undefined, "normal");
    y += 6; // aire real

    const kvs = [];
    if (typeof datos === "string") {
      kvs.push(["Datos", String(datos)]);
    } else if (typeof datos === "object") {
      const preferidos = [
        "beneficiario",
        "banco",
        "cuenta",
        "clabe",
        "swift",
        "aba",
        "referencia",
        "moneda",
        "direccionBanco",
      ];
      const vistos = new Set();

      preferidos.forEach((k) => {
        if (datos[k] != null && datos[k] !== "") {
          kvs.push([k, String(datos[k])]);
          vistos.add(k);
        }
      });

      Object.keys(datos).forEach((k) => {
        if (!vistos.has(k) && datos[k] != null && datos[k] !== "") {
          kvs.push([k, String(datos[k])]);
        }
      });

      if (kvs.length === 0) kvs.push(["Información", JSON.stringify(datos)]);
    } else {
      return y;
    }

    // 1) Precalcular líneas y alto real
    const items = kvs.map(([labelRaw, value]) => {
      const label = labelRaw.charAt(0).toUpperCase() + labelRaw.slice(1);
      const lines = doc.splitTextToSize(String(value), valueW);
      const rowH = Math.max(lineH, lines.length * (lineH - 0.5));
      return { label, lines, rowH };
    });

    const contentHeight =
      innerPad * 2 + items.reduce((acc, it) => acc + it.rowH, 0);

    // 2) Dibujar cuadro con alto correcto (el top del cuadro arranca un poco arriba)
    doc.roundedRect(
      startX - 2,
      y - innerPad,
      maxWidth + 4,
      contentHeight,
      2,
      2
    );

    // 3) Pintar texto dentro
    let yy = y;
    for (const it of items) {
      doc.setFont(undefined, "bold");
      doc.text(`${it.label}:`, startX, yy);
      doc.setFont(undefined, "normal");
      doc.text(it.lines, valueX, yy);
      yy += it.rowH;
    }

    // cursor después del recuadro
    return y - innerPad + contentHeight + 2;
  };

  // =========================
  // 1) Aplicar SEARCH (igual que commentsData)
  // =========================
  let computedComments = [...(comments || [])];

  if (search) {
    computedComments = computedComments.filter((c) => includesSearch(c, search));
  }

  // =========================
  // 2) Aplicar SORTING (si existe en tu componente)
  // =========================
  if (typeof sorting !== "undefined" && sorting?.field) {
    computedComments.sort((a, b) =>
      compareValues(a, b, sorting.field, sorting.order)
    );
  }

  // =========================
  // 3) Aplicar filtros del PDF (los tuyos)
  // =========================
  const clienteSet = new Set((selectedClienteFiltro || []).map(String));
  const conceptoSet = new Set((selectedConceptoFiltro || []).map(String));

  let totalGeneral = 0;
  const filas = [];

  for (const c of computedComments) {
    const pasaClientes = !clienteSet.size || clienteSet.has(String(c.idCliente));

    const pasaConceptos =
      !conceptoSet.size || conceptoSet.has(String(c.idConceptosGastos));

    if (
      (selectedFechaInicio == 0 || selectedFechaInicio <= c.fecha) &&
      (selectedMayorQue == 0 || selectedMayorQue <= c.total) &&
      (selectedMenorQue == 0 || selectedMenorQue >= c.total) &&
      (validado == 0 || validado == c.validado) &&
      pasaConceptos &&
      pasaClientes &&
      (selectedDuplicadoFiltro == 0 ||
        selectedDuplicadoFiltro == c.gastoDuplicado) &&
      (selectedProveedorFiltro == 0 ||
        selectedProveedorFiltro == c.idProveedor) &&
      (selectedFechaFin == 0 || selectedFechaFin >= c.fecha) &&
      (selectedActivo == 0 || selectedActivo == c.is_active) &&
      // ✅ excluir los gastos desmarcados en la columna PDF
      !excludedPdfIds.includes(String(c._id))
    ) {
      totalGeneral += Number(c.total || 0);

      filas.push({
        provNombre: c.proveedor ?? "SIN PROVEEDOR",
        datosBancarios: c.datosBancarios ?? c.cuentaBancaria ?? null,
        duplicado: c.gastoDuplicado === "Si",
        totalNum: Number(c.total || 0),
        cells: [
          c.fecha,
          c.concepto,
          c.contenedor,
          c.referencia,
          c.validado,
          formatUSD(c.total),
        ],
      });
    }
  }

  // =========================
  // 4) Agrupar por proveedor
  // =========================
  const grupos = new Map();
  for (const f of filas) {
    if (!grupos.has(f.provNombre)) {
      grupos.set(f.provNombre, {
        datosBancarios: f.datosBancarios ?? null,
        rows: [],
        total: 0,
      });
    }
    const g = grupos.get(f.provNombre);
    if (!g.datosBancarios && f.datosBancarios) g.datosBancarios = f.datosBancarios;
    g.rows.push(f);
    g.total += f.totalNum;
  }

  // =========================
  // 5) PDF
  // =========================
  const doc = new jsPDF("landscape");

  try {
    const img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
  } catch {}
  try {
    const img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 15, 25, 25);
  } catch {}

  doc.setFontSize(14);
  doc.text("Detalle de Gastos Contenedor", 20, 25);

  const head = [
    ["Fecha", "Concepto", "Contenedor", "Referencia", "Validado", "Importe"],
  ];

  let cursorY = 45;
  const margenIzq = 20;

  const gruposOrdenados = Array.from(grupos.entries()).sort(([a], [b]) =>
    String(a).localeCompare(String(b), "es", { sensitivity: "base" })
  );

  for (const [provNombre, g] of gruposOrdenados) {
    if (cursorY > 180) {
      doc.addPage("landscape");
      cursorY = 20;
    }

    doc.setFontSize(12);
    doc.setFont(undefined, "bold");
    doc.text(`Proveedor: ${provNombre}`, margenIzq, cursorY);
    doc.setFont(undefined, "normal");
    cursorY += 6;

    // ✅ ya no se enciman: el recuadro calcula el alto real
    cursorY = drawDatosBancarios(doc, g.datosBancarios, margenIzq, cursorY, 200) + 2;

    const bodyRows = g.rows.map((r) => r.cells);

    doc.autoTable({
      head,
      body: bodyRows,
      startY: cursorY,
      styles: { fontSize: 10 },
      margin: { left: margenIzq, right: 14 },
      showFoot: "lastPage",
      foot: [["", "", "", "", "Total Grupo", formatUSD(g.total)]],
      didParseCell: function (data) {
        if (data.section === "body") {
          const fila = g.rows[data.row.index];
          if (fila?.duplicado) data.cell.styles.fillColor = [255, 165, 0];
        }
      },
    });

    cursorY = doc.lastAutoTable.finalY + 10;
  }

  if (cursorY > 180) {
    doc.addPage("landscape");
    cursorY = 20;
  }

  doc.setFont(undefined, "bold");
  doc.text("Total general:", margenIzq, cursorY);
  doc.setFont(undefined, "normal");
  doc.text(formatUSD(totalGeneral), margenIzq + 35, cursorY);

  // Observaciones
  const obs = String(observaciones || "").trim();
  if (obs) {
    cursorY += 8;
    if (cursorY > 175) {
      doc.addPage("landscape");
      cursorY = 20;
    }

    doc.setFontSize(11);
    doc.setFont(undefined, "bold");
    doc.text("Observaciones:", margenIzq, cursorY);
    cursorY += 6;

    doc.setFont(undefined, "normal");
    const maxW = 260;
    const obsLines = doc.splitTextToSize(obs, maxW);
    const estH = obsLines.length * 5;

    if (cursorY + estH > 190) {
      doc.addPage("landscape");
      cursorY = 20;
    }

    doc.text(obsLines, margenIzq, cursorY);
    cursorY += estH;
  }

  doc.save("DetalleGastos_por_proveedor.pdf");
}

function excel() {
  // =========================
  // 1) SEARCH (igual que tu useMemo)
  // =========================
  let computedComments = [...(comments || [])];

  if (search) {
    computedComments = computedComments.filter((c) => matchesSearch(c, search));
  }

  // =========================
  // 2) FILTROS (los tuyos)
  // =========================
  const clienteSet = new Set((selectedClienteFiltro || []).map(String));
  const conceptoSet = new Set((selectedConceptoFiltro || []).map(String));

  const dataExcelLimpia = computedComments
    .map((c) => {
      const pasaClientes = !clienteSet.size || clienteSet.has(String(c.idCliente));
      const pasaConceptos = !conceptoSet.size || conceptoSet.has(String(c.idConceptosGastos));

      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= c.fecha) &&
        (selectedMayorQue == 0 || selectedMayorQue <= c.total) &&
        (selectedMenorQue == 0 || selectedMenorQue >= c.total) &&
        (validado == 0 || validado == c.validado) &&
        pasaConceptos &&
        pasaClientes &&
        (selectedDuplicadoFiltro == 0 || selectedDuplicadoFiltro == c.gastoDuplicado) &&
        (selectedProveedorFiltro == 0 || selectedProveedorFiltro == c.idProveedor) &&
        (selectedFechaFin == 0 || selectedFechaFin >= c.fecha) &&
        // ✅ FIX: es is_active (no activo)
        (selectedActivo == 0 || selectedActivo == c.is_active) &&
        // ✅ excluir los gastos desmarcados en la columna PDF
        !excludedPdfIds.includes(String(c._id))
      ) {
        return {
          Fecha: c.fecha,
          Duplicado: c.gastoDuplicado,
          Concepto: c.concepto,
          Contenedor: c.contenedor,
          Referencia: c.referencia,
          Cliente: c.cliente,
          Proveedor: c.proveedor,
          Descripcion: c.descripcion,
          Validado: c.validado,
          Importe: c.total,
        };
      }
      return null;
    })
    .filter(Boolean);

  // =========================
  // 3) EXPORT
  // =========================
  var option = {};
  option.fileName = `DetalleGastos-${selectedFechaInicio}-${selectedFechaFin}`;
  option.datas = [
    {
      sheetData: dataExcelLimpia,
      sheetName: `DetalleGastos`,
      sheetFilter: [
        "Fecha",
        "Duplicado",
        "Concepto",
        "Contenedor",
        "Referencia",
        "Cliente",
        "Proveedor",
        "Descripcion",
        "Validado",
        "Importe",
      ],
      sheetHeader: [
        "Fecha",
        "Duplicado",
        "Concepto",
        "Contenedor",
        "Referencia",
        "Cliente",
        "Proveedor",
        "Descripcion",
        "Validado",
        "Importe",
      ],
    },
  ];

  var toExcel = new ExportJsonExcel(option);
  toExcel.saveExcel();
}


  function enviaMail() {
    let totalMail = 0;

    const rows = comments
      .map((c) => {
        const pasaClientes =
          !selectedClienteFiltro?.length ||
          selectedClienteFiltro.includes(String(c.idCliente));

        const pasaConceptos =
          !selectedConceptoFiltro?.length ||
          selectedConceptoFiltro.includes(String(c.idConceptosGastos));

        if (
          (selectedFechaInicio == 0 || selectedFechaInicio <= c.fecha) &&
          (selectedMayorQue == 0 || selectedMayorQue <= c.total) &&
          (selectedMenorQue == 0 || selectedMenorQue >= c.total) &&
          (validado == 0 || validado == c.validado) &&
          pasaConceptos &&
          pasaClientes &&
          (selectedDuplicadoFiltro == 0 || selectedDuplicadoFiltro == c.gastoDuplicado) &&
          (selectedProveedorFiltro == 0 || selectedProveedorFiltro == c.idProveedor) &&
          (selectedFechaFin == 0 || selectedFechaFin >= c.fecha)&&
        (selectedActivo == 0 || selectedActivo == c.activo)
        ) {
          totalMail += Number(c.total || 0);

          const importePDF = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
            // roundingIncrement: 5,
          }).format(c.total);

          return [
            c.fecha,
            c.concepto,
            c.contenedor,
            c.proveedor,
            c.descripcion,
            c.validado,
            importePDF,
          ];
        }
        return null;
      })
      .filter(Boolean);

    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 15, 25, 25);

    doc.text("Detalle de Gastos Contenedor", 20, 25);

    doc.autoTable({
      head: [["Fecha", "Concepto", "Contenedor", "Proveedor", "Descripcion", "Validado", "Importe"]],
      body: rows,
      startY: 45,
      foot: [
        [
          "",
          "",
          "",
          "",
          "",
          "Total",
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
            // roundingIncrement: 5,
          }).format(totalMail),
        ],
      ],
      showFoot: "lastPage",
    });

    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Lista de Gastos Contenedor",
          email: mailTo,
          fileName: "ListaGastos.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
            <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
            <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
            <tbody>
              <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
              <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras la lista de Gastos Contenedor.</tr>
            </tbody>
            <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
            <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
          </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error?.response?.data ?? error?.message ?? ""}`,
        });
        console.log(error);
      });
  }

  const editGasto = (event) => {
    const URL_GASTOS_CONTENEDOR_EDIT = `${process.env.REACT_APP_URL_GASTOS_CONTENEDOR}/${idEdit}`;
    event.preventDefault();

    axios
      .patch(
        URL_GASTOS_CONTENEDOR_EDIT,
        {
          fecha: hoy,
          totalUSD: total,
          tipoCambio,
          total,
          abonos: 0,
          saldo: total,
          descripcion,
          conceptosGastos: selectedConcepto,
          contenedores: selectedContenedor,
          proveedores: selectedProveedor,
          clientes: selectedCliente,
          moneda,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Edit Gasto",
            detalle: `Fecha: ${fecha} / Descripcion: ${descripcion} `,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        toggleEdit();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => window.location.reload(), 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error?.response?.data ?? error?.message ?? ""}`,
        });
        console.log(error);
      });
  };

  const headers = [
    { name: `${t("Numero")}`, field: "numero", sortable: true },
    { name: `${t("Fecha")}`, field: "fecha", sortable: true },
    { name: "Proveedor", field: "proveedor", sortable: true },
    { name: `${t("Duplicado")}`, field: "gastoDuplicado", sortable: true },
    { name: `${t("Concepto")}`, field: "concepto", sortable: true },
    { name: `${t("Contenedor")}`, field: "contenedor", sortable: true },
    { name: `${t("Referecnia")}`, field: "referencia", sortable: true },
    { name: `${t("Cliente")}`, field: "cliente", sortable: true },
    { name: "TC", field: "tipoCambio", sortable: true },
    { name: `${t("Importe")}`, field: "total", sortable: true },
    { name: `${t("Abonos")}`, field: "abonos", sortable: true },
    { name: `${t("Saldo")}`, field: "saldo", sortable: true },
    { name: `${t("Validado")}`, field: "validado", sortable: false },
    { name: `${t("Editar")}`, field: "editar", sortable: false },
  { name: "✓", field: "select", sortable: false }, // ✅ NUEVO
  { name: "PDF", field: "pdf", sortable: false }, // ✅ incluir en PDFTabla
  ];

  const commentsData = useMemo(() => {
    let computedComments = [...comments];

    if (search) {
      computedComments = computedComments.filter((comment) =>
        matchesSearch(comment, search)
      );
    }

    if (selectedMayorQue) {
      computedComments = computedComments.filter(
        (e) => e.total >= selectedMayorQue
      );
    }

    if (selectedMenorQue) {
      computedComments = computedComments.filter(
        (e) => e.total <= selectedMenorQue
      );
    }

    // ✅ multi conceptos
    if (selectedConceptoFiltro?.length) {
      computedComments = computedComments.filter((e) =>
        selectedConceptoFiltro.includes(String(e.idConceptosGastos))
      );
    }

    // ✅ multi clientes
    if (selectedClienteFiltro?.length) {
      computedComments = computedComments.filter((e) =>
        selectedClienteFiltro.includes(String(e.idCliente))
      );
    }

    if (selectedDuplicadoFiltro) {
      computedComments = computedComments.filter((e) =>
        String(e.gastoDuplicado).includes(selectedDuplicadoFiltro)
      );
    }

    if (selectedProveedorFiltro) {
      computedComments = computedComments.filter((e) =>
        String(e.idProveedor).includes(selectedProveedorFiltro)
      );
    }

        if (selectedActivo) {
      computedComments = computedComments.filter((e) =>
        e.is_active.includes(selectedActivo)
      );
    }

            let cos = computedComments.map((c) => parseFloat(c.total));
    let TCos = cos.reduce((t, total, index) => t + total, 0);
    setTotalTotalGastos(TCos);

    setTotalItems(computedComments.length);

    // Sorting
    if (
      sorting.field &&
      sorting.field !== "total" &&
      sorting.field !== "abonos" &&
      sorting.field !== "saldo" &&
      sorting.field !== "numero" &&
      sorting.field !== "tipoCambio"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments.sort((a, b) =>
        reversed *
        String(a[sorting.field] ?? "").localeCompare(
          String(b[sorting.field] ?? "")
        )
      );
    }

    if (
      sorting.field &&
      (sorting.field === "total" ||
        sorting.field === "abonos" ||
        sorting.field === "saldo" ||
        sorting.field === "numero" ||
        sorting.field === "tipoCambio")
    ) {
      const asc = sorting.order === "asc";
      computedComments.sort((a, b) => {
        const av = parseFloat(a[sorting.field] ?? 0);
        const bv = parseFloat(b[sorting.field] ?? 0);
        return asc ? (av > bv ? 1 : -1) : av < bv ? 1 : -1;
      });
    }

    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedMayorQue,
    selectedMenorQue,
    selectedConceptoFiltro,
    selectedClienteFiltro,
    selectedDuplicadoFiltro,
    selectedProveedorFiltro,
    selectedActivo
  ]);

  const calcula = (e) => {
    setTotalUSD(e);
    setTotal(parseFloat(e) * parseFloat(tipoCambio));
  };

  const calculaTipoCambio = (e) => {
    setTipoCambio(e);
    setTotal(parseFloat(totalUSD) * parseFloat(e));
  };

  const parseMonto = (v) => {
  if (v === null || v === undefined) return 0;

  // convierte a string y limpia
  let s = String(v).trim();

  // manejo de formato contable: (123.45) => -123.45
  if (/^\(.*\)$/.test(s)) {
    s = "-" + s.replace(/[()]/g, "");
  }

  // quita comas y símbolos
  s = s.replace(/,/g, "");

  const n = Number(s);
  return isNaN(n) ? 0 : n;
};

  function importarArchivo(event) {
    const target = event.target;
    const name = target.name;
    let hojas = [];

    if (name === "file") {
      let reader = new FileReader();
      reader.readAsArrayBuffer(target.files[0]);
      reader.onloadend = (e) => {
        var data = new Uint8Array(e.target.result);
        var workbook = XLSX.read(data, { type: "array" });

        workbook.SheetNames.forEach(function (sheetName) {
          var XL_row_object = XLSX.utils.sheet_to_json(
            workbook.Sheets[sheetName]
          );
          hojas.push({ data: XL_row_object, sheetName });
        });

        let A1 = hojas?.[0]?.data || [];

        const contenedoresMap = {};
        contenedores
          .filter((cont) => cont.is_active === "Si")
          .forEach((cont) => {
            contenedoresMap[String(cont.referencia || "").trim()] = cont;
          });

        const conceptosGastosMap = {};
        conceptosGastos.forEach((concepto) => {
          const key = String(concepto?.name || "").trim().toLowerCase();
          if (key) conceptosGastosMap[key] = concepto._id;
        });

        const contenedoresNoEncontrados = new Set();
        const conceptosNoEncontrados = new Set();
        const nuevos = [];

        for (const a of A1) {
          const referencia = String(a?.REFERENCIA || "").trim();
          const conceptoKey = String(a?.CONCEPTO || "").trim().toLowerCase();

          const cont = contenedoresMap[referencia];
          const conceptoId = conceptosGastosMap[conceptoKey];

          if (cont) {
            if (conceptoId) {
              nuevos.push({
              id: uuidv4(),
              contenedores: cont._id,
              contenedoresNombre: cont.referencia,
              descripcion: a?.DESCRIPCION,
              monto: parseMonto(a?.IMPORTE),   // 👈 AQUÍ
              totalUSD: parseMonto(a?.USD),
              tipoCambio: parseMonto(a?.TC),
              cliente: cont?.clientes?.[0]?._id,
              clienteNombre: cont?.clientes?.[0]?.nombre_comercial,
              concepto: conceptoId,
              conceptoNombre: a?.CONCEPTO,
              cuentaBancaria: a?.CUENTABANCARIA,
              });
            } else {
              conceptosNoEncontrados.add(String(a?.CONCEPTO || "").trim());
            }
          } else {
            contenedoresNoEncontrados.add(referencia);
          }
        }

        if (
          contenedoresNoEncontrados.size > 0 ||
          conceptosNoEncontrados.size > 0
        ) {
          Swal.fire({
            title: "Elementos no encontrados",
            html: `
              ${
                contenedoresNoEncontrados.size > 0
                  ? `<b>Contenedores:</b> ${[
                      ...contenedoresNoEncontrados,
                    ].join(", ")}<br>`
                  : ""
              }
              ${
                conceptosNoEncontrados.size > 0
                  ? `<b>Conceptos:</b> ${[...conceptosNoEncontrados].join(", ")}`
                  : ""
              }
            `,
            icon: "warning",
            confirmButtonText: "Entendido",
          });
        }

        setInputFields((prev) => [...prev, ...nuevos]);

        const totalImp = [...inputFields, ...nuevos]
          .filter((x) => Number(x.monto) != 0)
          .reduce((acc, x) => acc + Number(x.monto || 0), 0);

        setTotalMonto(totalImp);
      };
    }
  }
// console.log("hola", inputFields)
  const saveGasto = async () => {
    setValidaBoton(false);
    toggleProgreso();

    try {
      await Promise.all(
        inputFields
          .filter((e) => Number(e.monto) != 0)
          .map((a) =>
            axios.post(
              `${URL_GASTOS_CONTENEDOR}`,
              {
                fecha: fechaGasto,
                totalUSD: a.totalUSD,
                tipoCambio: a.tipoCambio,
                total: a.monto,
                abonos: 0,
                saldo: a.monto,
                descripcion: a.descripcion,
                conceptosGastos: a.concepto,
                contenedores: a.contenedores,
                proveedores: selectedProveedor,
                bancos: selectedBanco,
                clientes: a.cliente,
                moneda,
                cuentaBancaria: a.cuentaBancaria,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
          )
      );

      await axios.post(
        URL_LOGS,
        {
          tipo: "Subir Gastos Contenedores",
          detalle: `${totalMonto}`,
          user: user.id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      Swal.fire("Good job!", "Creado con éxito", "success");
      setTimeout(() => window.location.reload(), 1000);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
      console.log(error);
      setValidaBoton(true);
    }
  };

  async function validadoGasto(idValida) {
    await axios
      .patch(
        `${URL_GASTOS_CONTENEDOR}Validado/${idValida}`,
        { validado: "Si" },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        Swal.fire("Good job!", "Actualizado con exito", "success");
        const newComments = comments.map((i) => {
          if (idValida === i._id) i.validado = "Si";
          return i;
        });
        setComments(newComments);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error?.response?.data ?? error?.message ?? ""}`,
        });
        console.log(error);
      });
  }

function cancelarGastoContenedor(idGastoContenedor) {
  Swal.fire({
    title: "Estas seguro?",
    text: "Se cancelara el Gasto Contenedor!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, Cancelar!",
  }).then((result) => {
    if (result.isConfirmed) {
      axios
        .get(`${URL_GASTOS_CONTENEDOR}Cancel/${idGastoContenedor}`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then(() => {
          Swal.fire("Good job!", "Enviado con exito", "success");

          const newComments = comments.map((i) => {
            if (String(idGastoContenedor) === String(i._id)) {
              return {
                ...i,
                total: 0,
                saldo: 0,
                totalUSD: 0,
                is_active: "No",
              };
            }
            return i;
          });

          setComments(newComments);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error?.response?.data ?? error?.message ?? ""}`,
          });
          console.log(error);
        });
    }
  });
}


// ✅ IDs cancelables en la página visible
const visibleCancellableIds = useMemo(() => {
  return (commentsData || [])
    .filter(
      (c) =>
        c.is_active === "Si" &&
        Number(c.saldo) === Number(c.total) &&
        c.validado === "No"
    )
    .map((c) => String(c._id));
}, [commentsData]);

const allVisibleSelected =
  visibleCancellableIds.length > 0 &&
  visibleCancellableIds.every((id) => selectedCancelIds.includes(id));

const toggleSelectAllVisible = () => {
  setSelectedCancelIds((prev) => {
    if (allVisibleSelected) {
      // des-seleccionar los visibles
      return prev.filter((id) => !visibleCancellableIds.includes(id));
    }
    // agregar visibles
    return Array.from(new Set([...prev, ...visibleCancellableIds]));
  });
};
async function cancelarGastosSeleccionados() {
  const ids = Array.from(new Set((selectedCancelIds || []).map(String)));

  if (!ids.length) return;

  const { isConfirmed } = await Swal.fire({
    title: "¿Estas seguro?",
    text: `Se cancelarán ${ids.length} gastos contenedor.`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, Cancelar!",
  });

  if (!isConfirmed) return;

  try {
    await Promise.all(
      ids.map((id) =>
        axios.get(`${URL_GASTOS_CONTENEDOR}Cancel/${id}`, {
          headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
        })
      )
    );

    Swal.fire("Good job!", "Cancelados con éxito", "success");

    // reflejar en tabla
    setComments((prev) =>
      prev.map((i) => {
        if (ids.includes(String(i._id))) {
          return { ...i, total: 0, saldo: 0, totalUSD: 0, is_active: "No" };
        }
        return i;
      })
    );

    setSelectedCancelIds([]);
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something went wrong!",
      footer: `${error?.response?.data ?? error?.message ?? ""}`,
    });
    console.log(error);
  }
}

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_gastos ? (
        <div className="row">
          <div className="col-md-12">
            <div className="card style={{ width: 'auto' }}">
              <div className="card-body">
                <Row>
                  <Col md={7}>
                    <Button
                      size="sm"
                      href="/MenuCXP"
                      className="btn btn-danger"
                      id="botonListado"
                    >
                      {t("Regresar")}
                    </Button>
                  </Col>
                  <Col md={5}>
                    <ButtonGroup id="logoutBoton">
                      <Button
                        size="sm"
                        className="btn"
                        color="danger"
                        onClick={toggleArchivo}
                      >
                        Archivo <i className="fas fa-upload"></i>
                      </Button>
                      <Button
                        size="sm"
                        className="btn"
                        color="danger"
                        onClick={() => {
                          setObservacionesPDF("");
                          setModalObs(true);
                        }}
                      >
                        PDF <i className="far fa-file-pdf"></i>
                      </Button>
                      <Button
                        size="sm"
                        className="btn"
                        color="info"
                        onClick={toggleMail}
                      >
                        eMail <i className="fas fa-at"></i>
                      </Button>
                      <Button size="sm" className="btn" color="primary" onClick={excel}>
                        Excel <i className="far fa-file-excel"></i>
                      </Button>
                    </ButtonGroup>
                  </Col>
                </Row>

                <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
                  <ModalHeader toggle={toggleMail}>
                    <h4>{t("Enviar correo")}</h4>
                  </ModalHeader>
                  <ModalBody>
                    <Label className="mr-sm-2">Email</Label>
                    <Input
                      className="col-sm-12"
                      type="text"
                      value={mailTo}
                      required
                      onChange={(e) => setMailTo(e.target.value)}
                    />
                  </ModalBody>
                  <ModalFooter>
                    <Button size="sm" color="success" onClick={enviaMail}>
                      {t("Enviar")}
                    </Button>
                  </ModalFooter>
                </Modal>

                <br />
                <h3 align="center">{t("Gastos Contenedor")}</h3>

                <Row>
                  <Col md={2}>
                    <Label>{t("Fecha Inicio")}</Label>
                    <Input
                      bsSize="sm"
                      type="date"
                      value={selectedFechaInicio}
                      onChange={(e) => setSelectedFechaInicio(e.target.value)}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>{t("Fecha Fin")}</Label>
                    <Input
                      bsSize="sm"
                      type="date"
                      value={selectedFechaFin}
                      onChange={(e) => setSelectedFechaFin(e.target.value)}
                    />
                  </Col>
                  <Col md={2}>
                    <Label className="mr-sm-2">{t("Mayor Que (Importe)")}</Label>
                    <Input
                      bsSize="sm"
                      type="number"
                      value={selectedMayorQue}
                      required
                      onChange={(e) => setSelectedMayorQue(e.target.value)}
                    />
                  </Col>
                  <Col md={2}>
                    <Label className="mr-sm-2">{t("Menor Que (Importe)")}</Label>
                    <Input
                      bsSize="sm"
                      type="number"
                      value={selectedMenorQue}
                      required
                      onChange={(e) => setSelectedMenorQue(e.target.value)}
                    />
                  </Col>
                  <Col md={2}>
                                <Label className="mr-sm-2">{t("Activo")}</Label>
                                <Input
                                  bsSize="sm"
                                  type="select"
                                  value={selectedActivo}
                                  required
                                  onChange={(e) => {
                                    setSelectedActivo(e.target.value);
                                  }}
                                >
                                  <option value="">{t("Selecciona")}</option>
                                  <option value="Si">{t("Activo")}</option>
                                  <option value="No">{t("Cancelado")}</option>
                                </Input>
                              </Col>

                </Row>

                <br />

                <div className="row">
                  <div className="col-md-6">
                    <Pagination
                      total={totalItems}
                      itemsPerPage={ITEMS_PER_PAGE}
                      currentPage={currentPage}
                      onPageChange={(page) => setCurrentPage(page)}
                    />
                  </div>
                  <div className="col-md-6 d-flex flex-row-reverse">
                    <Search
                      placeholder="Buscar... (varios contenedores separados por coma)"
                      onSearch={(value) => {
                        setSearch(value);
                        setCurrentPage(1);
                      }}
                    />
                  </div>
                </div>
<ButtonGroup className="me-2">
  <Button
    size="sm"
    color="danger"
    disabled={!selectedCancelIds.length}
    onClick={cancelarGastosSeleccionados}
  >
    <i className="fas fa-ban"></i> Cancelar seleccionados ({selectedCancelIds.length})
  </Button>

  <Button
    size="sm"
    color="secondary"
    outline
    onClick={() => setSelectedCancelIds([])}
  >
    Limpiar
  </Button>
</ButtonGroup>
                <Table size="sm" striped borderless className="table-responsive-xl">
                  <TableHeader
                    headers={headers}
                    onSorting={(field, order) => setSorting({ field, order })}
                  />

                  {/* filtros */}
                  <tr>
                    <td></td>
                    <td></td>

                    <td style={{ paddingTop: "0px" }}>
                      <Input
                        bsSize="sm"
                        type="select"
                        value={selectedProveedorFiltro}
                        required
                        onChange={(e) => setSelectedProveedorFiltro(e.target.value)}
                      >
                        <option value="">{t("Selecciona")}</option>
                        {proveedores
                          .sort((a, b) => (a.name > b.name ? 1 : -1))
                          .map((a) => (
                            <option key={a._id} value={a._id}>
                              {a.name}
                            </option>
                          ))}
                      </Input>
                    </td>

                    <td style={{ paddingTop: "0px" }}>
                      <Input
                        bsSize="sm"
                        type="select"
                        value={selectedDuplicadoFiltro}
                        required
                        onChange={(e) => setSelectedDuplicadoFiltro(e.target.value)}
                      >
                        <option value="">{t("Selecciona")}</option>
                        <option value="Si">{t("Si")}</option>
                        <option value="No">{t("No")}</option>
                      </Input>
                    </td>

                    {/* ✅ Concepto multi checkbox dropdown (igual que cliente) */}
                    <td style={{ paddingTop: "0px" }}>
                      <UncontrolledDropdown>
                        <DropdownToggle
                          caret
                          size="sm"
                          tag="button"
                          style={{
                            width: 180,
                            textAlign: "left",
                            backgroundColor: "#ffffff",
                            color: "#374151",
                            border: "1px solid #d1d5db",
                            borderRadius: 6,
                            padding: "3px 10px",
                            boxShadow: "none",
                          }}
                        >
                          {selectedConceptoFiltro?.length
                            ? `Conceptos (${selectedConceptoFiltro.length})`
                            : "Conceptos"}
                        </DropdownToggle>

                        <DropdownMenu
                          end
                          style={{
                            width: 320,
                            padding: 10,
                            maxHeight: 360,
                            overflow: "auto",
                            backgroundColor: "#ffffff",
                            color: "#212529",
                            borderRadius: 8,
                            border: "1px solid #e5e7eb",
                            boxShadow: "0 10px 25px rgba(0,0,0,.12)",
                            zIndex: 9999,
                          }}
                        >
                          <MultiSelectCheckbox
                            items={conceptosConDatos}
                            selected={selectedConceptoFiltro}
                            setSelected={setSelectedConceptoFiltro}
                            getId={(x) => x._id}
                            getLabel={(x) => x.name}
                            searchPlaceholder="Buscar concepto..."
                          />
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </td>

                    <td></td>
                    <td></td>

                    {/* ✅ Cliente multi checkbox dropdown */}
                    <td style={{ paddingTop: "0px" }}>
                      <UncontrolledDropdown>
                        <DropdownToggle
                          caret
                          size="sm"
                          tag="button"
                          style={{
                            width: 180,
                            textAlign: "left",
                            backgroundColor: "#ffffff",
                            color: "#374151",
                            border: "1px solid #d1d5db",
                            borderRadius: 6,
                            padding: "3px 10px",
                            boxShadow: "none",
                          }}
                        >
                          {selectedClienteFiltro?.length
                            ? `Clientes (${selectedClienteFiltro.length})`
                            : "Clientes"}
                        </DropdownToggle>

                        <DropdownMenu
                          end
                          style={{
                            width: 320,
                            padding: 10,
                            maxHeight: 360,
                            overflow: "auto",
                            backgroundColor: "#ffffff",
                            color: "#212529",
                            borderRadius: 8,
                            border: "1px solid #e5e7eb",
                            boxShadow: "0 10px 25px rgba(0,0,0,.12)",
                            zIndex: 9999,
                          }}
                        >
                          <MultiSelectCheckbox
                            items={clientesConDatos}
                            selected={selectedClienteFiltro}
                            setSelected={setSelectedClienteFiltro}
                            getId={(x) => x._id}
                            getLabel={(x) => x.nombre_comercial}
                            searchPlaceholder="Buscar cliente..."
                          />
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </td>

                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                     <td style={{ paddingTop: "0px" }}>
    <input
      type="checkbox"
      checked={allVisibleSelected}
      disabled={!visibleCancellableIds.length}
      onChange={toggleSelectAllVisible}
      title="Seleccionar todos los cancelables visibles"
    />
  </td>
                  </tr>

                  <tbody>
                    {commentsData.map((c) => {
                      totalTabla = totalTabla + Number(c.total || 0);

                      if (c.is_active == "Si") {
                        return (
                          <tr
                            key={c._id}
                            style={{
                              backgroundColor:
                                c.gastoDuplicado === "Si" ? "orange" : undefined,
                            }}
                          >
                            <td>{c.numero}</td>
                            <td>{c.fecha}</td>
                            <td>{c.proveedor}</td>
                            <td>{c.gastoDuplicado}</td>
                            <td>{c.concepto}</td>
                            <td>{c.contenedor}</td>
                            <td>{c.referencia}</td>
                            <td>{c.cliente}</td>
                            <td>{c.tipoCambio}</td>
                            <td>
                              {new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: "USD",
                                maximumFractionDigits: 2,
                                // roundingIncrement: 5,
                              }).format(c.total)}
                            </td>
                            <td>
                              {new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: "USD",
                                maximumFractionDigits: 2,
                                // roundingIncrement: 5,
                              }).format(c.abonos)}
                            </td>
                            <td>
                              {new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: "USD",
                                maximumFractionDigits: 2,
                                // roundingIncrement: 5,
                              }).format(c.saldo)}
                            </td>
                            <td>
                              <Button
                               size="sm"
                               className="btn"
                               color={c.validado === "No" ? "danger" : "primary"}
                               disabled={!user?.validarGastos || c.validado !== "No"}
                               onClick={() =>
                                 user?.validarGastos &&
                                 c.validado === "No" &&
                                 validadoGasto(c._id, c.idBanco)
                               }
                             >
                               {c.validado}
                             </Button>
                             
                            </td>

                            <td>
                              {c.saldo == c.total && c.validado == "No" ? (
                                <Button
                                  size="sm"
                                  className="btn"
                                  color="danger"
                                  onClick={() => cancelarGastoContenedor(c._id)}
                                >
                                  <i className="fas fa-ban"></i>
                                </Button>
                              ) : (
                                <Button size="sm" className="btn" color="danger" disabled>
                                  <i className="fas fa-ban"></i>
                                </Button>
                              )}

                              {c.saldo == c.total && c.validado == "No" ? (
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={() => {
                                    setIdEdit(c._id);
                                    setFecha(c.fecha);
                                    setTotalUSD(c.totalUSD);
                                    setTipoCambio(c.tipoCambio);
                                    setTotal(c.total);
                                    setDescripcion(c.descripcion);
                                    setSelectedConcepto(c.idConceptosGastos);
                                    setSelectedContenedor(c.idContenedor);
                                    setSelectedProveedor(c.idProveedor);
                                    setSelectedCliente(c.idCliente);
                                    setMoneda(c.moneda);
                                    toggleEdit();
                                  }}
                                >
                                  <i className="fas fa-edit"></i>
                                </Button>
                              ) : (
                                <Button color="info" id="Editar" size="sm" disabled>
                                  <i className="fas fa-edit"></i>
                                </Button>
                              )}
                            </td>
                            <td>
  <input
    type="checkbox"
    checked={selectedCancelIds.includes(String(c._id))}
    disabled={!(Number(c.saldo) === Number(c.total) && c.validado == "No")}
    onChange={(e) => {
      const id = String(c._id);
      const ok = e.target.checked;

      setSelectedCancelIds((prev) =>
        ok ? Array.from(new Set([...prev, id])) : prev.filter((x) => x !== id)
      );
    }}
  />
</td>
                            <td>
  <input
    type="checkbox"
    checked={!excludedPdfIds.includes(String(c._id))}
    onChange={(e) => {
      const id = String(c._id);
      const incluir = e.target.checked;

      setExcludedPdfIds((prev) =>
        incluir ? prev.filter((x) => x !== id) : Array.from(new Set([...prev, id]))
      );
    }}
  />
</td>
                          </tr>
                        );
                      }

                      return (
                        <tr key={c._id} style={{ backgroundColor: "#ed8c8c" }}>
                          <td>{c.numero}</td>
                          <td>{c.fecha}</td>
                          <td>{c.proveedor}</td>
                          <td>{c.gastoDuplicado}</td>
                          <td>{c.concepto}</td>
                          <td>{c.contenedor}</td>
                          <td>{c.referencia}</td>
                          <td>{c.cliente}</td>
                          <td>{c.tipoCambio}</td>
                          <td>
                            {new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                              maximumFractionDigits: 2,
                              // roundingIncrement: 5,
                            }).format(c.total)}
                          </td>
                          <td></td>
                          <td>CANCELADO</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>
                            <input
                              type="checkbox"
                              checked={!excludedPdfIds.includes(String(c._id))}
                              onChange={(e) => {
                                const id = String(c._id);
                                const incluir = e.target.checked;
                                setExcludedPdfIds((prev) =>
                                  incluir
                                    ? prev.filter((x) => x !== id)
                                    : Array.from(new Set([...prev, id]))
                                );
                              }}
                            />
                          </td>
                        </tr>
                      );
                    })}

                    <tr>
                      <td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>
                      <td className="negrita" align="center">TOTAL</td>
                      <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(totalTotalGastos)}
                </td>
                      <td></td><td></td><td></td><td></td><td></td><td></td>
                    </tr>
                  </tbody>
                </Table>

                <div className="col-md-6">
                  <Pagination
                    total={totalItems}
                    itemsPerPage={ITEMS_PER_PAGE}
                    currentPage={currentPage}
                    onPageChange={(page) => setCurrentPage(page)}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* EDIT */}
          <Modal size="lg" isOpen={modalEdit} toggle={toggleEdit}>
            <ModalHeader toggle={toggleEdit}>
              <h4> {t("Editar Gasto")}</h4>
            </ModalHeader>
            <ModalBody>
              <Row>
                <Col md={6}>
                  <Label className="mr-sm-2">{t("Fecha")}</Label>
                  <Input type="date" placeholder="Fecha" value={fecha} required disabled />
                </Col>
                <Col md={6}>
                  <Label className="mr-sm-2">{t("Contenedor")}</Label>
                  <Input type="select" required value={selectedContenedor} disabled>
                    <option value="0">{t("Selecciona")}</option>
                    {contenedores
                      .sort((a, b) => (a.numeroInterno > b.numeroInterno ? 1 : -1))
                      .map((a) => (
                        <option key={a._id} value={a._id}>
                          {a.numeroInterno}
                        </option>
                      ))}
                  </Input>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Label className="mr-sm-2">Proveedor</Label>
                  <Input type="select" required value={selectedProveedor} disabled>
                    <option value="0">{t("Selecciona")}</option>
                    {proveedores
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => (
                        <option key={a._id} value={a._id}>
                          {a.name}
                        </option>
                      ))}
                  </Input>
                </Col>

                <Col md={6}>
                  <Label className="mr-sm-2">{t("Cliente")}</Label>
                  <Input type="select" required value={selectedCliente} disabled>
                    <option value="0">{t("Selecciona")}</option>
                    {clientes
                      .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                      .map((a) => (
                        <option key={a._id} value={a._id}>
                          {a.nombre_comercial}
                        </option>
                      ))}
                  </Input>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Label className="mr-sm-2">{t("Concepto")}</Label>
                  <Input
                    type="select"
                    required
                    value={selectedConcepto}
                    onChange={(e) => setSelectedConcepto(e.target.value)}
                  >
                    <option value="0">{t("Selecciona")}</option>
                    {conceptosGastos
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => (
                        <option key={a._id} value={a._id}>
                          {a.name}
                        </option>
                      ))}
                  </Input>
                </Col>

                <Col md={6}>
                  <Label className="mr-sm-2">{t("Descripcion")}</Label>
                  <Input
                    type="text"
                    placeholder="Descripcion"
                    value={descripcion}
                    required
                    onChange={(e) => setDescripcion(e.target.value)}
                  />
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Label className="mr-sm-2">{t("Moneda")}</Label>
                  <Input
                    type="select"
                    required
                    value={moneda}
                    onChange={(e) => {
                      setMoneda(e.target.value);
                      setTotalUSD(0);
                      setTotal(0);
                      setTipoCambio(1);
                    }}
                  >
                    <option value="MXN">{t("MXN")}</option>
                    <option value="USD">{t("USD")}</option>
                  </Input>
                </Col>
              </Row>

              {moneda === "USD" ? (
                <Row>
                  <Col sm={4}>
                    <Label className="mr-sm-2">{t("Total USD")}</Label>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      placeholder="TotalUSD"
                      value={totalUSD}
                      required
                      onChange={(e) => calcula(e.target.value)}
                    />
                  </Col>
                  <Col sm={4}>
                    <Label className="mr-sm-2">Tipo de Cambio</Label>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      placeholder="TipoCambio"
                      value={tipoCambio}
                      required
                      onChange={(e) => calculaTipoCambio(e.target.value)}
                    />
                  </Col>
                  <Col sm={4}>
                    <Label className="mr-sm-2">{t("Total MXN")}</Label>
                    <Input type="number" min="0" step="any" value={total} disabled />
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col sm={4}>
                    <Label className="mr-sm-2">{t("Total MXN")}</Label>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      value={total}
                      onChange={(e) => {
                        setTotal(e.target.value);
                        setTotalUSD(e.target.value / tipoCambio);
                      }}
                    />
                  </Col>
                </Row>
              )}
            </ModalBody>
            <ModalFooter>
              <Button color="success" onClick={editGasto}>
                {t("Guardar")}
              </Button>
            </ModalFooter>
          </Modal>

          {/* ARCHIVO */}
          <Modal size="xl" isOpen={modalArchivo} toggle={toggleArchivo}>
            <ModalHeader toggle={toggleArchivo}>
              <h4>{t("Subir Archivo")}</h4>
            </ModalHeader>
            <ModalBody>
              <Row>
                <Col md={4}>
                  <Label className="mr-sm-2">{t("Fecha")}</Label>
                  <Input
                    type="date"
                    placeholder="Fecha"
                    value={fechaGasto}
                    required
                    onChange={(e) => setFechaGasto(e.target.value)}
                  />
                </Col>

                <Col md={4}>
                  <Label className="mr-sm-2">Proveedor</Label>
                  <Input
                    type="select"
                    required
                    value={selectedProveedor}
                    onChange={(e) => setSelectedProveedor(e.target.value)}
                  >
                    <option value="0">{t("Selecciona")}</option>
                    {proveedores
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => (
                        <option key={a._id} value={a._id}>
                          {a.name}
                        </option>
                      ))}
                  </Input>
                </Col>

                <Col md={4}>
                  <Label className="mr-sm-2">Banco</Label>
                  <Input
                    type="select"
                    value={selectedBanco}
                    required
                    onChange={(e) => setSelectedBanco(e.target.value)}
                  >
                    <option value="">Selecciona un Banco</option>
                    {bancos
                      .sort((a, b) => (a.banco > b.banco ? 1 : -1))
                      .map((a) => {
                        if (a.moneda == moneda) {
                          return (
                            <option key={a._id} value={a._id}>
                              {a.banco} {a.cuenta}
                            </option>
                          );
                        }
                        return null;
                      })}
                  </Input>
                </Col>
              </Row>

              <br />

              <Row>
                <Col md={9}>
                  <Input required type="file" name="file" id="file" onChange={importarArchivo} />
                </Col>
                <Col md={3}>
                  <h4>
                    Total{" "}
                    {new Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                      maximumFractionDigits: 2,
                    }).format(totalMonto)}
                  </h4>
                </Col>
              </Row>

              <br />

              <Table bordered striped>
                <thead>
                  <tr>
                    <th>Contenedor</th>
                    <th>Cliente</th>
                    <th>Concepto</th>
                    <th>Descripción</th>
                    <th>USD</th>
                    <th>TC</th>
                    <th>Monto</th>
                    <th>Cuenta Bancaria</th>
                  </tr>
                </thead>
                <tbody>
                  {inputFields
                    .filter((a) => Number(a.monto) != 0)
                    .map((a) => (
                      <tr key={a.id}>
                        <td>{a.contenedoresNombre}</td>
                        <td>{a.clienteNombre}</td>
                        <td>{a.conceptoNombre}</td>
                        <td>{a.descripcion}</td>
                        <td>
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            maximumFractionDigits: 2,
                          }).format(a.totalUSD)}
                        </td>
                        <td>
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            maximumFractionDigits: 2,
                          }).format(a.tipoCambio)}
                        </td>
                        <td>
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            maximumFractionDigits: 2,
                          }).format(a.monto)}
                        </td>
                        <td>{a.cuentaBancaria}</td>
                      </tr>
                    ))}
                </tbody>
              </Table>

              <br />

              {validaBoton ? (
                <Button color="success" onClick={() => saveGasto()}>
                  Guardar
                </Button>
              ) : (
                <Button color="success" disabled>
                  Guardar
                </Button>
              )}
            </ModalBody>
          </Modal>

          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>{t("Progreso")}</h4>
            </ModalHeader>
            <ModalBody>
              Estamos enviando los correos, este proceso puede tardar varios minutos.
              <br />
              {t("Por favor no cierre ni refresque su navegador.")}
              <br />
              <div className="divPadre2">
                <div className="divHijo2">
                  <Spinner style={{ width: "3rem", height: "3rem", color: "#232B41" }} />
                  <Spinner style={{ width: "3rem", height: "3rem", color: "#232B41" }} />
                  <Spinner style={{ width: "3rem", height: "3rem", color: "#232B41" }} />
                </div>
              </div>
            </ModalBody>
          </Modal>

          <Modal isOpen={modalObs} toggle={toggleModalObs} size="lg">
            <ModalHeader toggle={toggleModalObs}>Observaciones para el PDF</ModalHeader>

            <ModalBody>
              <Label>Observaciones</Label>
              <Input
                type="textarea"
                rows="6"
                value={observacionesPDF}
                onChange={(e) => setObservacionesPDF(e.target.value)}
                placeholder="Escribe aquí las observaciones que quieres que aparezcan al final del PDF..."
              />
            </ModalBody>

            <ModalFooter>
              <Button color="secondary" onClick={toggleModalObs}>
                Cancelar
              </Button>

              <Button
                color="danger"
                onClick={() => {
                  setModalObs(false);
                  PDFTabla(observacionesPDF);
                }}
              >
                Descargar PDF
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      ) : null}
      {loader}
    </>
  );
}

export default ListadoGastosContenedor;
